import styled, { css } from 'styled-components';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { motion } from 'framer-motion';
import { BiChevronLeft } from 'react-icons/bi';
import { LogoIcon } from '~/assets/svgs';
import { FiLogOut } from 'react-icons/fi';

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  justify-content: space-between;
  background-color: #fafafc;
`;

export const WrapperContent = styled.div`
  flex: 1;
  padding: 3.8rem 3.5%;
  position: relative;
  padding-top: 0;

  @media (min-width: 1280px) {
    margin-left: ${({ noDrawer }) => (noDrawer ? 0 : 25.7)}rem;
  }

  transition: 300ms ease;
`;

export const PaddingTop = styled.div`
  padding-top: 14rem;
`;

export const Content = styled.div``;

export const Drawer = styled.div`
  height: 100vh;
  width: 100vw;
  max-width: 25.7rem;
  background-color: #fff;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.04);
  display: flex;
  position: fixed;
  z-index: 200;
  line-height: 41px;

  @media (max-width: 1279px) {
    transform: ${({ drawerOpened }) =>
      drawerOpened ? 'translateX(0)' : 'translateX(-25.7rem)'};
  }

  ${({ noDrawer }) =>
    noDrawer &&
    css`
      transform: translateX(-25.7rem)};
    `}

  transition: 300ms ease;

  display: flex;
  flex-direction: column;
`;

export const FooterDrawer = styled.div`
  margin-bottom: 3.8rem;
`;

export const LogoutCompanyButton = styled.div`
  display: flex;
  align-items: center;
  padding: 0.7rem 3.2rem;
  gap: 1rem;
  font-family: ${({ theme }) => theme.fonts.Poppins};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.base[400]};
  cursor: pointer;

  :hover {
    filter: brightness(0.5);
  }

  transition: 300ms ease;
`;

export const LogoutLabel = styled.div`
  font-size: 1.2rem;
`;

export const LogOutIcon = styled(FiLogOut)`
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.base[400]};
`;

export const Scroll = styled(PerfectScrollbar)`
  flex: 1;
  padding: 20% 5% 20% 10%;
  position: relative;
`;

export const LogoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Logo = styled(LogoIcon)`
  width: 13rem;
  object-fit: contain;
`;

export const ContainerItem = styled.div`
  position: relative;
  margin: 2.5rem 0;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ButtonBack = styled.div`
  width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.24);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid #539ada;
  position: fixed;
  border-radius: 999px;
  z-index: 99999;
  top: 40px;
  left: 240px;
  align-items: center;
  padding: 0px;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  animation: entrance 0.3s ease 0s 1 normal none;

  @keyframes entrance {
    0% {
      transform: scale(0);
    }

    100% {
      transform: scale(1);
    }
  }

  @media (min-width: 1280px) {
    display: none;
  }

  @media (max-width: 990px) {
    left: 190px;
  }
`;

export const WrapperItem = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex: 1;
  cursor: pointer;
  position: relative;

  :hover {
    transform: scale(1.05) translateX(3%);
  }

  transition: 200ms ease;

  p {
    font-size: 1.2rem;
    color: ${({ theme, active }) =>
      active ? theme.colors.blue : theme.colors.base[500]};
    font-weight: 400;
    margin-left: 1.5rem;
    ${({ theme }) => theme.notSelectable};
  }
`;

export const Indicator = styled(motion.div)`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.blue};
  width: 0.5rem;
  height: 3.1rem;
  right: -6%;
  border-radius: 0.25rem;
`;

export const Arrow = styled(BiChevronLeft).attrs(({ theme }) => ({
  color: theme.colors.blueSecondary,
  size: 26,
}))``;
